import React from "react";
import { Box, Icons } from '@curves/ui-base';
import { parseDate } from "@Util/moment";

const MeasurementDateChip = ({ measureDate }) => {
	return (
		<Box className="measurement-date__container">
			<Box className="measurement-date__chip">
				<Icons.CalendarDays className="measurement-date__icon"  />
				<span className="measurement-date__text">
					<span className="measurement-date__text-label">最近量身日: </span>
					<span className="measurement-date__text-value">{parseDate(measureDate, "YYYY/M/D HH:mm") || "—"}</span>
				</span>
			</Box>
		</Box>
	);
};

export default MeasurementDateChip;
